module.exports = __webpack_public_path__ + "img/indy-best.5f91c1b.jpg";